const redirectToPath = (path: string) => {
  if (typeof window !== 'undefined') {
    window.location.href = window.location.origin + path;
  }
};

export default redirectToPath;
